import React, { useContext } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { Trans, useTranslation } from '@wix/yoshi-flow-editor';
import { st, classes } from '../../../Widget.st.css';
import { AppContext } from '../../SettingsProvider/SettingsProvider';

const NoQuestionsResult = () => {
  const { searchTerm } = useContext(AppContext);
  const noQuestionResultSearch = searchTerm !== '';
  const { t } = useTranslation();
  return (
    <div className={st(classes.Body, { noResult: true })}>
      <Text className={st(classes.noResultText)}>
        <Trans
          tOptions={{ interpolation: { escapeValue: false } }}
          i18nKey={
            noQuestionResultSearch
              ? 'widget.search.tab.no.search.results.found'
              : 'widget.search.tab.no.results.found'
          }
          values={{
            tryAgain: noQuestionResultSearch
              ? t('widget.search.tab.no.search.results.found.try.again')
              : t('widget.search.tab.no.results.found.try.again'),
          }}
        >
          <div></div>
        </Trans>
      </Text>
    </div>
  );
};

export default NoQuestionsResult;
